module.exports = __webpack_public_path__ + "static/media/top-no-older-than-me-active-light-icon.b34d689b.svg";